<template>
  <v-app id="updHsii">
    
    <defNavBar title="Ares - Layout" :home="true"/>

    <v-main> 
      <v-card class="ma-2">
        <span class="px-2">Accommodation: {{huis.huis_code}} </span>
      </v-card>
      <v-container fluid>

        <v-btn v-if="this.hsiiDisplay == 'summary'" x-small @click="reloadScreen('detailed')" class="primary ma-2">Detailed</v-btn>
        <v-btn v-if="this.hsiiDisplay == 'detailed'" x-small @click="reloadScreen('summary')" class="primary ma-2">Summary</v-btn>
        
        <v-btn class="primary ma-2" x-small @click="upd1Hsii(huis.huis_encrid,0)">Add layout toplevel item</v-btn>
        <v-treeview ref="x" :items="huis.hsii" item-key="id" dense>
              <template slot="label" slot-scope="{ item }">
               <a @click="upd1Hsii(huis.huis_encrid,item.id)">{{ item.name }}</a>
              </template>
        </v-treeview>
        <upd1Hsii ref="upd1Hsii"></upd1Hsii>
      </v-container>
    </v-main>
  </v-app>
</template>




<script>
 import upd1Hsii from "@/views/huis/hsii/upd1Hsii.vue"; 
 import defNavBar from '@/components/ui/navbars/navbar.vue';
 export default {
  components: {
      defNavBar,
      upd1Hsii
  },
  props: ['huis_encrid','hsiiDisplay'],
  data() {
    return {
      huis: {
        action_items: []  /* moet pre defined ivm length check */
      },
      expand: false
    }
    
  },
  mounted() {
    this.$axios
      .post("ares/json/ares/huis/hsii/getHsii.p", {
        header: {
          token: this.$session.get("ARES"),
          clientSessionId: this.$session.id(),
          request: "getHsii"
        },
        getHsii: {
          huis_encrid: this.huis_encrid,
          hsiiDisplay: this.hsiiDisplay
       }
      })
      .then(res => {
        if (res.data.error) {
          console.log(res.data.error);
        } else {
           this.huis = res.data.getHsii;
        }
      })
      .finally(() => {
        this.$refs.x.updateAll(true);
      });
  },
  methods: {
    upd1Hsii(huis_encrid,hsii_encrid) {
      this.$refs.upd1Hsii.open(huis_encrid,hsii_encrid,this.hsiiDisplay);
    },
    collapseTree() {
      this.$refs.x.updateAll(false);
      this.expand = false;
    },
    expandTree() {
      this.$refs.x.updateAll(true);
      this.expand = true;
    },
    reloadScreen(what) {
       this.$router.reload('/huis/hsii/updHsii/' + this.huis_encrid + '/' + what);
    }
  }  
};

</script> 
